export default {
  page: () => import("/var/jenkins_home/workspace/qboson-web/layouts/page.vue").then(m => m.default || m)
}